import React from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Text } from '@moda/om';
import { useReturn } from '../../hooks/useReturn';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { ReturnOrderItem } from '../OrderItem/ReturnOrderItem';

import './ReturnSummaryItems.scss';

export const ReturnSummaryItems: React.FC = () => {
  const { shipmentNumber } = useParams();
  const { returnOrderItems, error: returnError } = useReturn(shipmentNumber);

  if (returnError) throwQueryError(returnError);
  if (!returnOrderItems) return null;

  return (
    <Stack space={4}>
      <Text treatment="h5">Items Requested for Return</Text>
      {returnOrderItems.map(item => (
        <div key={item.id} className="ReturnSummaryItems__item">
          <ReturnOrderItem item={item} />
        </div>
      ))}
    </Stack>
  );
};
